import { Dispatch } from "@reduxjs/toolkit";
import { turnOffDevice } from "@utils/api-communication/RestApiCli";
import { getProductId } from "@utils/api-communication/WsUtil";
import { clearEyeTrackingFailure } from "@store/connection/connectionSlice";
import { resetTestState } from "@store/tests/testSlice";
import { resetTestSession } from "@store/testsession/testSessionSlice";
import { clearTestSuite } from "@store/testSuite/testSuiteSlice";
import { updateDeviceStatus, updateScene } from "@actions/productActions";
import { DEVICE_STATUS } from "@components/new_test_ui/new_test_steps/common/DeviceStatus";
import { markHeadsetRebootPending } from "@utils/headsetRebootPending";

export function requestHeadsetReboot(): Promise<void> {
  const pid = getProductId();
  if (!pid) return Promise.reject(new Error("Missing productId"));
  return new Promise((resolve, reject) => {
    turnOffDevice(
      { reboot: true, pid },
      (response) => {
        const delivered = response?.data === true || response?.data === "true";
        if (delivered) {
          markHeadsetRebootPending(pid);
          resolve();
          return;
        }
        reject(new Error("Headset reboot command was not delivered"));
      },
      (err) => reject(err),
    );
  });
}

export function clearRunStateForNewSession(dispatch: Dispatch): void {
  dispatch(clearEyeTrackingFailure());
  dispatch(clearTestSuite());
  dispatch(resetTestSession());
  dispatch(resetTestState());
  dispatch(updateScene("", null));
  dispatch(updateDeviceStatus(DEVICE_STATUS.NotConnected));
}
